import React from 'react';
import { Card } from "@/components/ui/card";
import { User, Phone, DollarSign, CheckCircle } from 'lucide-react';

interface Lead {
  id: string;
  pipeline_stage: string;
  quoted_amount: number;
}

interface LeadsMetricsProps {
  leads: Lead[];
}

export const LeadsMetrics = ({ leads }: LeadsMetricsProps) => {
  const totalLeads = leads.length;
  const contactedLeads = leads.filter(lead => lead.pipeline_stage === 'Contacted').length;
  const quotedAmount = leads.reduce((sum, lead) => sum + (lead.quoted_amount || 0), 0);
  const convertedLeads = leads.filter(lead => lead.pipeline_stage === 'Sold').length;

  const metrics = [
    {
      title: "Total Leads",
      value: totalLeads.toString(),
      icon: User,
      iconBg: "bg-blue-100",
      iconColor: "text-blue-500"
    },
    {
      title: "Contacted",
      value: contactedLeads.toString(),
      icon: Phone,
      iconBg: "bg-green-100",
      iconColor: "text-green-500"
    },
    {
      title: "Quoted Amount",
      value: `$${quotedAmount.toLocaleString()}`,
      icon: DollarSign,
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-500"
    },
    {
      title: "Converted",
      value: convertedLeads.toString(),
      icon: CheckCircle,
      iconBg: "bg-purple-100",
      iconColor: "text-purple-500"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics.map((metric) => (
        <Card key={metric.title} className="p-6">
          <div className="flex items-start space-x-4">
            <div className={`p-3 rounded-full ${metric.iconBg}`}>
              <metric.icon className={`w-6 h-6 ${metric.iconColor}`} />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">{metric.title}</p>
              <h3 className="text-2xl font-bold mt-1">{metric.value}</h3>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};